import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ISurveyForCompanyRepository } from 'application/repositorySchemas/ISurveyForCompanyRepository';
import { type IAnswerSurveyForCompanyClient } from 'interfaceAdapter/gatewaySchemas/IAnswerSurveyForCompanyClient';

@injectable()
export class SurveyForCompanyRepository implements ISurveyForCompanyRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('IAnswerSurveyForCompanyClient')
        public readonly answerSurveyClient: IAnswerSurveyForCompanyClient,
    ) {}

    public async answer(matchId: number, answers: Array<number | string | null>) {
        const { data, message } = await this.answerSurveyClient.post({
            token: this.companyUserToken.get() || '',
            matchId,
            answers,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
